<template>
  <v-menu class="btn-menu" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="btnType === 'textBtn'"
        small
        text
        :class="position"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        style="text-transform: capitalize !important;"
      >
        {{ label }}
      </v-btn>
      <v-btn
        v-else-if="btnType === 'colorBtn'"
        x-small
        color="primary"
        :class="position"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
      >
        {{ label }}
      </v-btn>
      <v-btn
        v-else-if="btnType === 'widthIconBtn'"
        class="height-40 width-100 ma-0 ml-1"
        color="primary"
        :class="position"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
      <v-btn
        v-else-if="btnType === 'iconBtn'"
        x-small
        :class="position"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-icon color="primary">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="clickEventHandler(item)"
      >
        <v-list-item-content>
          <v-list-item-title v-text="item.text"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon v-if="item.icon">
          <v-icon small v-text="item.icon"></v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'arb-btn-menu',
  props: {
    /*
    * @description
    * value: the items which show in the list
    */
    value: {
      type: Array
    },
    /*
    * @description
    * label: the text which shows in button
    */
    label: {
      type: String
    },
    /*
    * @description
    * icon: the icon which shows in button
    */
    icon: {
      type: String
    },
    /*
    * @description
    * position: topLeft | topRight
    */
    position: {
      type: String,
      default: ''
    },
    /*
    * @description
    * btnType: textBtn | colorBtn
    */
    btnType: {
      type: String,
      default: 'textBtn'
    },
    /*
    * @description
    * belongTo: parent value
    */
    belongTo: {
      type: Object
    },
    /*
    * @description
    * disabled: make btn be disable
    */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: this.value
    }
  },
  watch: {
    value (val) {
      this.items = val
    }
  },
  methods: {
    clickEventHandler (item) {
      this.$emit('click', item.value) && this.belongTo && item.click(this.belongTo)
    }
  }
}
</script>
<style lang="scss" scoped>
.topLeft {
  position: fixed;
}
.topRight {
  position: fixed;
  top: inherit;
  right: 0;
}
.toLeft {
  position: absolute;
  top: inherit;
  left: 165px;
}

.toMLeft {
  position: absolute;
  top: inherit;
  left: 345px;
}

</style>
